import { routeToComponentName } from './route-to-component-name';

export const formatWordpressRoutes = ( routes = [], postTypeComponents = {} ) => {
	return routes.map( route => {
		const postId = route.post_id;
		const componentName = routeToComponentName( route );
		const component = postTypeComponents[ componentName ];

		const componentUrls = {
			PageDefault: `kla/v1/apps/`,
		};

		const chosenComponentUrl = componentUrls[ componentName ] || null;

		if ( component ) {
			return {
				path: `${route.slug }`,
				component: component,
				props: {
					postId,
				},
				meta: {
					postId,
					endpoint: chosenComponentUrl,
				},
			};
		} else {
			console.warn( `Post type component ${ componentName } for post type ${ route.post_type} not found for route ${ route.slug }` );
			return null;
		}
	})
		// Remove faulty routes
		.filter( route => route !== null );
};



// WEBPACK FOOTER //
// ./assets/_js/utils/format-wordpress-routes.js